import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { CirculationAreaCadastral } from './types';
import * as yup from 'yup';
import { CirculationAreaClient } from 'shell/view-models/circulation-area-client';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.AreacircolazioneQuery],
  create: [SystemAuthorizations.AreacircolazioneAdd],
  edit: [SystemAuthorizations.AreacircolazioneUpdate],
  delete: [SystemAuthorizations.AreacircolazioneDelete],
});

export const headCells: HeadCell<CirculationAreaClient, keyof CirculationAreaClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaToponymyFilter = yup.object({});

export const headCellsCadastral: HeadCell<
  CirculationAreaCadastral,
  keyof CirculationAreaCadastral
>[] = [
  {
    id: 'sheet',
    label: 'Foglio',
  },
  {
    id: 'particle',
    label: 'Particella',
  },
  {
    id: 'subordinate',
    label: 'Subalterno',
  },
  {
    id: 'address',
    label: 'Indirizzo',
  },
  {
    id: 'civic',
    label: 'Civico',
  },
  {
    id: 'dateStart',
    label: 'Data inizio blocco',
  },
  {
    id: 'dateEnd',
    label: 'Data fine blocco',
  },
  {
    id: 'action',
    label: '',
  },
];
